import { gql } from 'urql';

export const bannerMsgR2 = gql`
  fragment bannerMsgR2 on IBannerMessageR2 {
    __typename
    id
    type
    title
    message
    ... on RelinkPlaidAccountBannerMessage {
      id
      type
      title
      message
      cta
      relinkType
    }
    ... on ActionableBannerMessages {
      id
      type
      title
      message
      cta
      actionType
      __typename
    }
    ... on InformationalBannerMessage {
      id
      type
      title
      message
      articleLink {
        copy
        articleId
        article {
          title
          id
          ... on ZendeskArticle {
            id
            title
            articleId
            url
          }
        }
      }
      __typename
    }
    ... on DebitCardSetPinBannerMessage {
      id
      cardId
      type
      title
      message
      __typename
    }
    ... on SuspiciousCardTransactionBannerMessage {
      transactionId
      __typename
    }
  }
`;
